import { ApiService } from './api.service';
import { of, forkJoin } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { EventEmitter, Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/_service/auth.service';
@Injectable({ providedIn: 'root' })
export class SessionService {
	constructor(
		private api: ApiService,
		private auth: AuthService,
	) {}

	carrelloChange = new EventEmitter<any>();

	get(key) {
		const val = sessionStorage.getItem(key);
		return val ? JSON.parse(val) : null;
	}

	set(key, obj) {
		const object = obj ? JSON.stringify(obj) : null;
		sessionStorage.setItem(key, object);
	}

	getProdotti() {
		// const prodotti = this.get('prodotti');
		// if (prodotti) { return of(prodotti); }

		return this.api.listProdotti().pipe(
			map((prodotti: any) => {
				const user = this.auth.getUser();

				// Pesco solo i prodotti di cui almeno un prodotto commerciale ha il listino per il cliente
				prodotti.forEach((prodotto) => {
					prodotto.prodottiCommerciali.forEach((pc) => (pc.listini = pc.listini.filter((l) => l.cliente === user.cliente.codiceCliente)));
					prodotto.prodottiCommerciali = prodotto.prodottiCommerciali.filter((pc) => pc.listini.length > 0);
					prodotto.prodottiCommerciali.forEach((pc) => (pc.giacenzaMagazzino = this.calcolaGiacenzaMagazzino(pc)));
				});

				prodotti = prodotti.filter((p) => p.prodottiCommerciali.length > 0);

				this.set('prodotti', prodotti);
				return prodotti;
			}),
		);
	}

	getAccessori() {
		return this.api.listAccessori().pipe(
			map((accessori: any) => {
				console.log('Accessories from API service: ', JSON.parse(JSON.stringify(accessori)));

				const user = this.auth.getUser();
				// Pesco solo i prodotti di cui almeno un prodotto commerciale ha il listino per il cliente
				accessori.forEach((accessorio) => {
					accessorio.prodottiCommerciali.forEach((pc) => (pc.listini = pc.listini.filter((l) => l.cliente === user.cliente.codiceCliente)));
					accessorio.prodottiCommerciali = accessorio.prodottiCommerciali.filter((pc) => pc.listini.length > 0);
					accessorio.prodottiCommerciali.forEach((pc) => (pc.giacenzaMagazzino = this.calcolaGiacenzaMagazzino(pc)));
				});

				accessori = accessori.filter((p) => p.prodottiCommerciali.length > 0);
				this.set('accessori', accessori);
				return accessori;
			}),
		);
	}

	getCarrello(update = false) {
		return this.api.getCarrello().pipe(
			map((result: any) => {
				this.set('carrello', result);
				this.carrelloChange.emit(result);
				return result;
			}),
		);
	}

	setCarrello(codiceTecnico, quantita, aggiungi) {
		return this.api.updateCarrello({ codiceTecnico, quantita, aggiungi, scontoAssoluto: null, scontoPercentuale: null }).pipe(
			map((result: any) => {
				this.updateCarrello();
				return result;
			}),
		);
	}

	svuotaCarrello() {
		this.getCarrello().subscribe((items) => {
			const obs = [];
			items.forEach((item) => {
				obs.push(this.api.updateCarrello({ codiceTecnico: item.prodottoCommerciale.codiceTecnico, quantita: 0, aggiungi: false }));
			});
			forkJoin(obs).subscribe(() => this.updateCarrello());
		});
	}

	updateCarrello() {
		this.getCarrello(true).subscribe();
	}

	calcolaGiacenzaMagazzino(prodottoCommerciale) {
		if (prodottoCommerciale?.magazzini && prodottoCommerciale.magazzini.length > 0) {
			return prodottoCommerciale.magazzini.reduce((acc, magazzino) => acc + magazzino.giacenza, 0);
		} else {
			return 0;
		}
	}
}
